import React, {useState, useEffect , useRef} from "react";
import { Link } from "react-router-dom";

import LeftMenuLayout from 'layouts/LeftMenuLayout';

import classNames from 'classnames';
import * as Yup from 'yup';
import {API_ENDPOINT, toast_anim } from 'components/config/Common'
import {Loading , WalletPointsIcon} from "components/custom-icons";

import axios from 'axios';  
import {APP_URL, APP_NAME , IMG_URL , LIMIT , amount_format} from 'components/config/Common'

import Helmet from 'react-helmet'
import { ReactSEOMetaTags } from 'react-seo-meta-tags'
import { toast } from 'react-toastify';
import ScrollPageTop from 'components/ui/ScrollPageTop'
import {Links} from 'routes/PathLink'

import { yupResolver } from '@hookform/resolvers/yup';
import Input from 'components/ui/input.jsx'
import Label from 'components/ui/label.tsx'
import Button from 'components/ui/Button.tsx'
import InfiniteScroll from "react-infinite-scroll-component";
import ModalView from '_utils/ModalView'
import Badge from "components/ui/badge/badge";
import NoRecords from 'pages/common/NoRecords';
import StickerCard from "components/widgets/sticker-card";
import { Tab } from '@headlessui/react'
import StockActionDash from  'pages/dashboard/StockActionDash';
import {
  useUserDashboardStatsQuery,
} from 'data/dashboard-data';

const MyDashboard = () => {
	
	const [access_token, setAccess_token] = useState(localStorage.getItem('access_token'))
	const [user_type, setUser_type] = useState(localStorage.getItem('user_type'))
	const [user_me, setUser_me] = useState(null);
	const [loading, setLoading] = useState(false);
	const [loading_social, setLoading_social] = useState(false);
	const [totalamount,setTotalamount] = useState(0);
	const [transactions,setTransactions]= useState([]);
	const [page, setPage] = useState(1)
   const [totalRec, setTotalRec] = useState(0)
   const [hasMore, setHasMore] = useState(true)
   const [openwithdraw ,setOpenwithdraw] = useState(false);

   const [currentab ,setcurrentab] = useState(0);

	const {
		  stats,      
		  paginatorInfo,
		  isLoading,
		  error,
		} = useUserDashboardStatsQuery({
		  page,
		});
	console.log("Dashboard Stats ",stats)

	return (
		<ScrollPageTop>
			
         <LeftMenuLayout> 
				<div className="w-full">
					<div className={classNames('bg-white dark:bg-zinc-800 w-full p-5 md:p-8  shadow rounded mb-8')}>
						{/*<p className="text-lg lg:text-xl text-heading capitalize mb-5 dark:text-zinc-400">Welcome You are logged In.</p>*/}
						
						<div className="flex mb-5 w-full justify-between flex-col md:flex-row ">
						<div className="w-full md:w-3/12 mb-5 flex flex-col">
							
							<Link to={Links.MYFORUMS}>
					            <StickerCard
					            titleTransKey="Total Forums"
					            icon={<WalletPointsIcon className="w-8 mr-2 text-3xl text-accent " size={40} />}
					            linkText={`${stats?.total_forum_posts}`}
					            link={`#`}
					          />
				          </Link>
						</div>
						<div className="w-full md:w-3/12 mb-5 flex flex-col ml-2">
							
							<Link to={Links.MYSCREENS}>
					            <StickerCard
					            titleTransKey="Total Screen Created"
					            icon={<WalletPointsIcon className="w-8 mr-2 text-3xl text-accent" size={40} />}
					            linkText={`${stats?.total_screens_created}`}
					            link={'#'}
					          />
				          </Link>
						</div>
						<div className="w-full md:w-3/12 mb-5 flex flex-col ml-2">
							
							<Link to={Links.MYFOLLOWEDSCREENS}>
					            <StickerCard
					            titleTransKey="Total Screens Followed"
					            icon={<WalletPointsIcon className="w-8 mr-2 text-3xl text-accent" size={40} />}
					            linkText={`${stats?.total_screens_followed}`}
					            link={'#'}
					          />
				          </Link>
						</div>
						
						</div>
						<div className="w-full  px-2 py-2 sm:px-0">
							
						</div>
						
					</div>
					<StockActionDash />
				</div>
		</LeftMenuLayout> 
      </ScrollPageTop>
   );
};

export default MyDashboard